import React, { Component, Fragment } from 'react';
import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * This represents the react-dropzone implementation.  All functionality
 * is handled at the parent component, but we have to initialize our
 * file drop handlers here.
 */
class Step4Dropzone extends Component {
  constructor() {
    super();
    this.state = {
      files: []
    };
  }

  onCancel() {
    this.setState({ files: [] });
  }

  render() {
    const { acceptedFileList, handleFileDrop, handleFileDropRejected } = this.props;

    return (
      <Fragment>
        <div className="mt-3">
          <Dropzone
            accept={acceptedFileList}
            onDropRejected={files => handleFileDropRejected(files)}
            onDrop={files => handleFileDrop(files)}
            onFileDialogCancel={() => this.onCancel()}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone-container cursor-pointer" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="dropzone-container-text">
                  <h2>Drag Files Here</h2>
                  <FontAwesomeIcon color="gray" icon="plus" />
                  <p className="color-blue">or choose file(s) from your computer</p>
                </div>
              </div>
            )}
          </Dropzone>
        </div>
      </Fragment>
    );
  }
}

export default Step4Dropzone;
